module.exports = __webpack_public_path__ + "static/media/60.5899044b.jpg";